import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ExcelPayload,
  NRTReportExcelResponse,
  NRTReportResponse,
  PayloadParam,
  ReportError,
  ReportExcelResponse,
  ReportResponse,
  UpdateNotePayload,
  UpdateNoteResponse,
} from '@core/interface/report';

export const ReportActions = createActionGroup({
  source: 'Report',
  events: {
    'Load Report': props<PayloadParam>(),
    'Load Report Success': props<ReportResponse>(),
    'Load Report Failure': props<ReportError>(),
    'Update Note': props<UpdateNotePayload>(),
    'Update Note Success': props<UpdateNoteResponse>(),
    'Update Note Failure': props<ReportError>(),
    'Reset Reports': emptyProps(),
    'Export Excel': props<ExcelPayload>(),
    'Export Excel Success': props<ReportExcelResponse>(),
    'Export Excel Failure': props<ReportError>(),
    'Load NRT Report': props<PayloadParam>(),
    'Load NRT Report Success': props<NRTReportResponse>(),
    'Load NRT Report Failure': props<ReportError>(),
    'Export NRT Excel': props<ExcelPayload>(),
    'Export NRT Excel Success': props<NRTReportExcelResponse>(),
    'Export NRT Excel Failure': props<ReportError>(),
  },
});
